import { UserRejectedError } from '@dynamic-labs-sdk/client';
import type {
  BitcoinNetwork,
  BitcoinProvider,
  SignMultiplePsbtPayload,
  SignTransactionResponse,
} from 'sats-connect';
import { signMultipleTransactions } from 'sats-connect';

type SignMultipleTransactionsWithSatsConnectParams = {
  network: BitcoinNetwork;
  provider?: BitcoinProvider;
  psbts: SignMultiplePsbtPayload[];
};

export const signMultipleTransactionsWithSatsConnect = async ({
  network,
  psbts,
  provider,
}: SignMultipleTransactionsWithSatsConnectParams): Promise<{
  signedPsbts: string[];
}> => {
  const response: SignTransactionResponse[] = await new Promise(
    (resolve, reject) => {
      void signMultipleTransactions({
        getProvider: () => Promise.resolve(provider),
        onCancel: () => {
          reject(
            new UserRejectedError({
              action: 'sign psbts',
            })
          );
        },
        onFinish: (response) => {
          resolve(response);
        },
        payload: {
          message: 'Sign Psbts',
          network,
          psbts,
        },
      });
    }
  );

  return {
    signedPsbts: response.map((response) => response.psbtBase64),
  };
};
